"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class BaseEntity extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'Verleng DV Plus mono 1jr',
        description: 'Name of the resource. The given example for a proposition.',
    }),
    tslib_1.__metadata("design:type", String)
], BaseEntity.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'vaste tarieven: DirectVoordeel Plus - tijdelijk aanbod',
        description: 'Short decription of the resource you are creating/updating. The given example for a proposition.',
    }),
    tslib_1.__metadata("design:type", String)
], BaseEntity.prototype, "description", void 0);
exports.default = BaseEntity;
